import { z } from "zod";
import type { CategoryPlugin } from "../plugin";

const schema = z.object({
  weight_g: z.number().positive().optional(),
  base: z.enum(["Beeswax","Jojoba","Shea"]).optional(),
  tin_material: z.enum(["Brass","Aluminium","Glass"]).optional(),
});

export const plugin: CategoryPlugin<z.infer<typeof schema>> = {
  metadata: {
    id: "solid-perfumes", slug: "solid-perfumes", name: "Solid Perfumes",
    tagline: "Balm-form fragrance to carry", status: "launched",
  },
  attributeSchema: schema,
  search: { columns: ["name","family","notes"], attributes: [] },
  facets: [
    { key: "family", label: "Family", type: "enum", source: "column",
      options: ["Floral","Oriental","Woody","Amber","Green"] },
    { key: "base", label: "Base", type: "enum", source: "attribute",
      options: ["Beeswax","Jojoba","Shea"] },
    { key: "weight_g", label: "Weight (g)", type: "range", source: "attribute",
      min: 5, max: 60, step: 1, unit: "g" },
    { key: "price", label: "Price (₹)", type: "range", source: "column",
      min: 20, max: 150, step: 5, unit: "₹" },
  ],
  pdpPanels: [
    { key: "product", label: "Product details", attributes: ["weight_g","base","tin_material"] },
  ],
  seo: {
    titleTemplate: "{name} · CB16 Solid Perfume",
    descriptionTemplate: "{name} — balm-form solid perfume for travel.",
    routePrefix: "solid-perfumes",
  },
  adminForm: [
    { key: "weight_g", label: "Weight (g)", kind: "number" },
    { key: "base", label: "Base", kind: "select", options: ["Beeswax","Jojoba","Shea"] },
    { key: "tin_material", label: "Tin material", kind: "select", options: ["Brass","Aluminium","Glass"] },
  ],
};
